module.exports = __webpack_public_path__ + "media/images/accountSection__settingsClose-201f3efd7f1413d87db538f5390d2fd9.png";